module.exports = __webpack_public_path__ + "img/wishOpen.2390b494.png";